jQuery.noConflict();
(function($) {
    $(document).ready(function() {
        $('.photoPreviousOverlay').hover(
            function(){
                $('.photoPreviousArrow').css('display', 'block');
                $('.photoNextArrow').css('display', 'block');
                $('.photoPreviousArrow').addClass('hoverState');
            },
            function(){
                $('.photoPreviousArrow').css('display', 'none');
                $('.photoNextArrow').css('display', 'none');
                $('.photoPreviousArrow').removeClass('hoverState');
            });

        $('.photoNextOverlay').hover(
            function(){
                $('.photoPreviousArrow').css('display', 'block');
                $('.photoNextArrow').css('display', 'block');
                $('.photoNextArrow').addClass('hoverState');
            },
            function(){
                $('.photoPreviousArrow').css('display', 'none');
                $('.photoNextArrow').css('display', 'none');
                $('.photoNextArrow').removeClass('hoverState');
            });
    });
})(jQuery);